import { useNavigate } from "react-router-dom";
import PageLayout from "./PageLayout ";

export default function Volunteer() {
  const navigate = useNavigate();
  return (
    <PageLayout
      title="Volunteer With Us"
      desc="Be a part of meaningful change through legal awareness, service, and social responsibility."
    >
      <div className="advocacy-content">
        <p>
          Volunteering is one of the most powerful ways to contribute towards
          building a just, aware, and responsible society. At ICSAJ
          (International Council of Sanatan Advocacy & Justice), we believe that
          real change begins when individuals step forward to serve with
          dedication, integrity, and a sense of purpose.
        </p>

        <p>
          Our volunteer programs are designed to engage individuals from diverse
          backgrounds who are passionate about legal awareness, advocacy, and
          social service. Whether you are a law student, practicing advocate,
          researcher, or simply a responsible citizen, your contribution can
          make a meaningful impact.
        </p>

        <p>
          Volunteers play a crucial role in supporting ICSAJ’s initiatives,
          including awareness campaigns, community outreach, research support,
          and assisting in legal aid activities. Through active participation,
          volunteers not only contribute to society but also gain valuable
          knowledge, experience, and exposure to real-world legal and social
          challenges.
        </p>

        <h4 className="mt-4">Why Volunteer With ICSAJ?</h4>

        <ul className="advocacy-list">
          <li>Gain practical exposure to legal and advocacy work</li>
          <li>Contribute towards social justice and awareness</li>
          <li>Work with experienced legal professionals</li>
          <li>Enhance your research, communication, and leadership skills</li>
          <li>Be part of a responsible and impactful community</li>
        </ul>

        <p>
          At ICSAJ, we emphasize ethical and responsible volunteering. Our
          approach is rooted in discipline, lawful conduct, and respect for
          society. Volunteers are encouraged to work in a structured manner,
          ensuring that all initiatives align with legal standards and promote
          harmony and awareness.
        </p>

        <p>
          We offer opportunities in various areas such as legal research,
          content creation, awareness campaigns, event coordination, and
          community engagement. Each role is designed to help volunteers grow
          personally and professionally while contributing to a larger cause.
        </p>

        <p>
          Volunteering is not just about giving time — it is about making a
          difference. By joining ICSAJ, you become part of a mission dedicated
          to justice, awareness, and positive societal transformation. Your
          efforts can help spread knowledge, support those in need, and
          strengthen the values of law and justice.
        </p>

        <p>
          We welcome individuals who are committed, responsible, and eager to
          learn. Together, we can create a network of volunteers who are not
          only aware but also actively contributing towards a better and more
          just society.
        </p>

        <div className="text-center mt-4">
          <button
            className="btn btn-danger px-4 py-2"
            onClick={() => navigate("/join-volunteer")}
          >
            Apply as Volunteer
          </button>
        </div>
      </div>
    </PageLayout>
  );
}
